import Collection from 'core/model/Collection';
import { computed } from 'mobx';

import NetworkHealthTestModel from './NetworkHealthTestModel';

class NetworkHealthAgentCollection extends Collection {
  get url() {
    return '/api/ui/network-availability/agent';
  }

  get model() {
    return NetworkHealthTestModel;
  }

  /**
   * @returns {number}
   */
  @computed
  get asnCount() {
    return new Set(this.models.map((model) => model.get('asn').id)).size;
  }

  /**
   * @returns {number}
   */
  @computed
  get countryCount() {
    return new Set(this.models.map((model) => model.get('geo').country.code)).size;
  }

  /**
   * @returns {number}
   */
  @computed
  get cityCount() {
    return new Set(this.models.map((model) => model.get('geo').city.id)).size;
  }
}

export default NetworkHealthAgentCollection;
